import { toast } from "react-toastify";
import {
  addSessionFailure,
  addSessionStart,
  addSessionSuccess,
  deleteSessionFailure,
  deleteSessionStart,
  deleteSessionSuccess,
  editSessionFailure,
  editSessionStart,
  editSessionSuccess,
  fetchSessionFailure,
  fetchSessionStart,
  fetchSessionSuccess,
  updateSessionStatusFailure,
  updateSessionStatusStart,
} from "./reducer";
import {
  addSessionService,
  deleteSessionService,
  editSessionService,
  getSessionListService,
  updateSessionStatusService,
} from "../../Services/SessionsService";

//thunk for fetch the category list
export const fetchSessionsList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchSessionStart());
      const response = await getSessionListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchSessionSuccess({
            sessions: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          }),
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchSessionSuccess({
            sessions: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          }),
        );
      } else {
        dispatch(fetchSessionFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchSessionFailure(error));
    }
  };

//thunk for the addig the category

export const addSession = (requestParam) => async (dispatch) => {
  try {
    dispatch(addSessionStart());

    const response = await addSessionService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addSessionSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addSessionFailure("Failed to add Session"));
    }
  } catch (error) {
    console.error("Error adding session:", error);
    toast.error(error);

    dispatch(addSessionFailure(error));
  }
};

// //this is the thunk for delete the category
export const deleteSession = (sessionId) => async (dispatch) => {
  try {
    dispatch(deleteSessionStart());

    const response = await deleteSessionService(sessionId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteSessionSuccess(sessionId));
    } else {
      toast.error("Failed to delete session");
      dispatch(deleteSessionFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteSessionFailure(error));
  }
};

// //this tunk for the edit meal category
export const editSession = (requestParam) => async (dispatch) => {
  try {
    dispatch(editSessionStart());

    const response = await editSessionService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editSessionSuccess(response));
    } else {
      dispatch(editSessionFailure("Failed to update session"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editSessionFailure(error));
  }
};

export const updateSessionStatus =
  (sessionId, newStatus) => async (dispatch, getState) => {
    try {
      dispatch(updateSessionStatusStart());

      const response = await updateSessionStatusService(sessionId, newStatus);
      if (response?.success) {
        // const state = getState();
        // const tax = state.taxes.find((u) => u.id === taxId);

        // if (tax) {
        //   const updatedTax = { ...tax, active };
        //   dispatch(updateTaxStatusSuccess(updatedTax));
        // }

        toast.success(
          response.message || "Session status updated successfully",
        );
      } else {
        dispatch(updateSessionStatusFailure("Failed to update  status"));
        toast.error("Failed to update user status");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
      dispatch(updateSessionStatusFailure(error));
    }
  };

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
